<template>
  <div class="background">
    <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
<!--      <el-row style="height: 10%; margin: 10px 0 20px 20px">-->
<!--        <el-col :span="18">-->
<!--          已预约时间段-->
<!--        </el-col>-->
<!--        <el-col :span="4">-->
<!--          <div class="block">-->
<!--            <el-date-picker-->
<!--                v-model="value"-->
<!--                type="date"-->
<!--                placeholder="选择日期">-->
<!--            </el-date-picker>-->
<!--          </div>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--      <el-row style="height: 100%">-->
        <div style="margin: 10px 0 20px 20px">
             <el-col :span="18">
          已预约时间段
        </el-col>
        <el-col :span="4">
          <div class="block">
            <el-date-picker
                v-model="value"
                type="date"
                placeholder="选择日期">
            </el-date-picker>
          </div>
        </el-col>
        </div>
        <div style="margin-left: 20px">
          <el-row>
            <el-col :span="4">
              <div>时间</div>
              <div v-for="(timeRange, index) in tableData" :key="index">
                <div class="timeStyle">
                  {{ timeRange.booking_time }}
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div>已进场人数/预约人数</div>

              <div v-for="(timeRange, index) in tableData" :key="index" style="margin-top: 10px;">
                <el-progress :percentage="progressPercentage" :stroke-width="30" :show-text="false"
                             :color="progressColor">{{ timeRange.ticketCheckedNum }}/{{ timeRange.reservationNum }}
                </el-progress>
                <!--                 <el-progress :percentage="progressPercentage[index]" :stroke-width="30" :show-text="false"-->
                <!--                                 :color="progressColor">{{ currentNumber[index] }}/{{ totalNumber[index] }}-->
                <!--                    </el-progress>-->
              </div>
            </el-col>
            <el-col :span="5" style="margin-left: 30px">
              <div>锁场人数</div>
              <div v-for="(timeRange, index) in tableData" :key="index" style="margin-top: 12px;">
                <el-input-number size="mini" v-model="index" @change="handleChange" :min="1" :max="10">1
                </el-input-number>
              </div>


            </el-col>
            <el-col :span="5">
              <div>锁场</div>
              <div v-for="(timeRange, index) in tableData" :key="index" style="margin-top: 10px;">
                <div class="timeStyle">
                  <i class="el-icon-lock">已锁</i>
                </div>


              </div>
            </el-col>
          </el-row>
        </div>
<!--      </el-row>-->
    </div>

  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "reservationNum",
  data() {
    return {
      value: new Date(),
      tableData: [],
      timeRanges: [],
      num4: 1,
      progressPercentage: 0,
      progressColor: '#5C16F2',
      currentNumber: 6, // 当前已预约人数，对应图中的6
      totalNumber: 2, // 总人数，对应图中的2，这里可能存在数据不合理的情况，假设总人数应该是10之类的
      timeDate: new Date()
    }
  },
  mounted() {
    this.calculatePercentage();
    this.reservationNumList();

  },
  created() {

    // this.generateTimeRanges();
  },
  methods: {
    calculatePercentage() {
      // 计算进度百分比
      this.progressPercentage = this.currentNumber / this.totalNumber;
    },
    // generateTimeRanges() {
    //   const start = 10; // 10:00
    //   const end = 21.5; // 21:30
    //   let currentTime = start;
    //
    //   while (currentTime <= end) {
    //     const startHour = Math.floor(currentTime);
    //     const startMinute = (currentTime % 1) * 60;
    //     const endHour = Math.floor(currentTime + 0.5);
    //     const endMinute = ((currentTime + 0.5) % 1) * 60;
    //
    //     const startTime = `${startHour}:${startMinute === 0 ? '00' : startMinute}`;
    //     const endTime = `${endHour}:${endMinute === 0 ? '00' : endMinute}`;
    //
    //     this.timeRanges.push(`${startTime}-${endTime}`);
    //     currentTime += 0.5; // increment by 30 minutes
    //   }
    // },
    reservationNumList() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      // 获取月，需要注意月份是从0开始计数的，所以要加1
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      // 获取日
      const day = String(currentDate.getDate()).padStart(2, '0');
      // 组合成指定格式的日期字符串
      var formattedDate = `${year}-${month}-${day}`;
      this.timeDate = formattedDate
      $.ajax({
        // url: 'https://dreamportal.nextscene.cn/api/orders/info',
        url: this.$settings.BASE_URL + "order/booking_list",
        type: 'POST',
        dataType: 'json',
        //new Date()
        // data: {'date': this.timeDate},
        data: {'date': this.timeDate},
                  xhrFields: {
        withCredentials: true
    },
        success: (res) => {
          console.log('res666', res)
          if (res.info == 'ok' && res.result.length > 0) {
            res.result.forEach(function (reservation) {
              var reservationData = {}
              if (reservation["sum(ticket_num)"] == 0) {
                reservationData["reservationNum"] = 0
              } else {
                reservationData["reservationNum"] = reservation["sum(ticket_num)"]
              }
              if (reservation.ticketChecked == "已核验") {
                reservationData["ticketCheckedNum"] = reservation["sum(ticket_num)"]
              } else {
                reservationData["ticketCheckedNum"] = 0
              }
            })
            this.tableData = res.result
          }
        },
        error: (error) => {
          console.log('请求失败：', error)
        }
      })
    },
  }
}
</script>

<style scoped>
.background {
  background-color: #F4F5FA;
  height: 100vh;
}


/*.el-calendar-table .el-calendar-day {*/
/*  height: 30px;*/
/*  width: 20px;*/
/*}*/

.timeStyle {
  width: 70%;
  height: 100%;
  padding: 3px;
  /*gap: 10px;*/
  border-radius: 10px;
  border: 2px solid #5C16F2;
  font-size: 15px;
  color: #5C16F2;
  text-align: center;
  margin-top: 10px;
}

.el-input, .el-button {
  margin-top: 0 !important;
}
</style>
